import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import i18n from "../../../../i18n";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
import { formatNorwegianNumber } from "utils/helper";
import React from "react";

let t = i18n.t;

export const PurchaseStatisticColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		//{
		//	field: "productCode",
		//	title: t("ProductCode"),
		//	className: `no-border`,
		//	cells: {
		//		data: (props) => {
		//			return <CellPopover {...props} />;
		//		},
		//		groupFooter: (props) => {
		//			if (props.dataItem?.field === "group1") {
		//				return <td className={`no-border td-bold`}></td>;
		//			} else {
		//				return (
		//					<td className={`no-border td-bold`}>
		//						<div style={{ marginTop: "20px" }}>
		//							Sum {props.dataItem.items[0].vesselName}
		//						</div>
		//					</td>
		//				);
		//			}
		//		},
		//		// groupHeader: (props) => {
		//		// 	return <td>dd</td>;
		//		// },
		//	},
		//},

		{
			field: "productName",
			title: t("Product"),
			cells: { data: (props) => <CellPopover {...props} /> },
			className: `no-border`,
		},

		{
			field: "netLiveWeightKg",
			title: t("Weight"),

			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} style={{}} />,

				headerCell: (props) => <NumericalHeader {...props} />,
				groupFooter: (props) => {
					let data = props.dataItem.aggregates.netLiveWeightKg;

					const minDecimal = 2;
					const maxDecimal = 2;
					if (props.dataItem?.field === "group1") {
						return <td className={`no-border td-bold`}></td>;
					}
					return (
						<td
							// aria-colindex={cellProps.columnIndex}

							className={`  ${CLASSNAME.TableNumeric} no-border td-bold`}
							// style={{ backgroundColor: "white" }}
						>
							<div style={{ marginTop: "20px" }}>
								{`${formatNorwegianNumber(
									data.sum,
									minDecimal,
									maxDecimal
								)} kg`}{" "}
							</div>
						</td>
					);
				},
				group: {
					groupFooter: (props) => {
						let data = props.dataItem.aggregates.netLiveWeightKg;
						//console.log("data", data);
						return (
							<td
								// aria-colindex={cellProps.columnIndex}
								className={`  ${CLASSNAME.TableNumeric} no-border td-bold`}
								// style={{ backgroundColor: "white" }}
							>
								{`${formatNorwegianNumber(data.sum, 2, 2)} kg`}
							</td>
						);
					},
				},
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "averagePrice",
			title: t("Price"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,

				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "amount",
			title: t("Amount"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,

				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "",
			title: "",
			width: "50px",
			className: `no-border`,
		},
	];
	return gridItems;
};

export const NumericalHeader: FC<
	GridHeaderCellProps & { style?: React.CSSProperties } & any
> = (props) => {
	return (
		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
			{props.title}
		</th>
	);
};
